
import React from "react";
import { Link } from "react-router-dom";
import { Button, ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface LinkButtonProps extends ButtonProps {
  to: string;
  className?: string;
  children: React.ReactNode;
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  to,
  className,
  children,
  ...props
}) => {
  return (
    <Button asChild className={cn(className)} {...props}>
      <Link to={to}>{children}</Link>
    </Button>
  );
};
